<r-widget-control>
  <img
    nz-image
    [name]="config.name"
    [width]="config.width"
    [height]="config.height"
    [nzSrc]="config.value"
    [nzFallback]="fallback"
    alt=""
  />
</r-widget-control>
